export enum ChangeHistoryBasicTypeEnum {
    UPDATE_STATUS = 'Status geändert',
    UPDATE_FIELD = 'Felder bearbeitet'
}

